(function() {
  const prescriptionForm = document.getElementById('PrescriptionForm')
  if (!prescriptionForm) return

  const newScriptRadio = document.getElementById('prescription-new')
  const repeatRadio = document.getElementById('prescription-repeat')
  const uploadField = document.getElementById('PrescriptionUploadField')
  const petNameInput = document.getElementById('pet-name')
  const productForm = document.getElementById('PdpForm')
  const petNameError = document.getElementById('pet-name-error')
  const uploadError = document.getElementById('prescription-upload-error')
  const fileSupport = document.getElementById('prescription-file-support')

  const UPLOADERY_INIT_DELAY = 1000
  const ERROR_BORDER_COLOR = '#D41706'
  const TOOLTIP_HIDE_DELAY = 300

  let isValidating = false

  function toggleUploadField() {
    const isRepeatPrescription = repeatRadio.checked
    uploadField.style.display = isRepeatPrescription ? 'none' : 'block'

    const uploaderyInput = uploadField.querySelector('input[type="file"]')
    if (uploaderyInput) {
      uploaderyInput.removeAttribute('required')
    }

    if (isRepeatPrescription) {
      if (uploadError) {
        uploadError.classList.add('hidden')
      }
      const fileUploadContainer = uploadField.querySelector('.spb-fileupload')
      if (fileUploadContainer) {
        fileUploadContainer.style.borderColor = ''
      }
    }
  }

  function validatePrescriptionForm(e) {
    isValidating = true
    const petName = petNameInput.value.trim()
    let isValid = true

    petNameError.classList.add('hidden')
    petNameInput.style.borderColor = ''
    uploadError.classList.add('hidden')
    if (fileSupport) {
      fileSupport.classList.remove('hidden')
    }
    const fileUploadContainer = uploadField.querySelector('.spb-fileupload')
    if (fileUploadContainer) {
      fileUploadContainer.style.borderColor = ''
    }

    if (!petName) {
      petNameError.classList.remove('hidden')
      petNameInput.style.borderColor = ERROR_BORDER_COLOR
      isValid = false
    }

    const prescriptionStatus = document.querySelector('input[name="properties[Prescription Status]"]:checked')
    if (!prescriptionStatus) {
      isValid = false
    }

    if (newScriptRadio.checked) {
      const uploaderyInput = uploadField.querySelector('input[type="file"]')
      if (uploaderyInput && !uploaderyInput.value) {
        uploadError.classList.remove('hidden')
        if (fileSupport) {
          fileSupport.classList.add('hidden')
        }
        const fileUploadContainer = uploadField.querySelector('.spb-fileupload')
        if (fileUploadContainer) {
          fileUploadContainer.style.borderColor = ERROR_BORDER_COLOR
        }
        isValid = false
      } else if (uploaderyInput && uploaderyInput.files && uploaderyInput.files[0]) {
        const filename = uploaderyInput.files[0].name
        if (newScriptRadio) {
          newScriptRadio.value = filename
        }
      }
    }

    isValidating = false

    if (!isValid) {
      e.preventDefault()
      e.stopPropagation()
      e.stopImmediatePropagation()
      return false
    }

    return true
  }

  function clearPetNameError() {
    if (isValidating) return

    petNameError.classList.add('hidden')
    petNameInput.style.borderColor = ''
  }

  petNameInput.addEventListener('click', clearPetNameError)
  petNameInput.addEventListener('focus', clearPetNameError)

  petNameInput.addEventListener('input', () => {
    if (petNameInput.value.trim()) {
      petNameError.classList.add('hidden')
      petNameInput.style.borderColor = ''
    }
  })

  const observeFileInput = () => {
    const clearUploadError = () => {
      uploadError.classList.add('hidden')
      if (fileSupport) {
        fileSupport.classList.remove('hidden')
      }
      const fileUploadContainer = uploadField.querySelector('.spb-fileupload')
      if (fileUploadContainer) {
        fileUploadContainer.style.borderColor = ''
      }
    }

    const observer = new MutationObserver(() => {
      const uploaderyInput = uploadField.querySelector('input[type="file"]')
      const fileUploadContainer = uploadField.querySelector('.spb-fileupload')

      if (uploaderyInput && fileUploadContainer) {
        const updatePrescriptionStatusWithFilename = () => {
          if (uploaderyInput.files && uploaderyInput.files[0]) {
            const filename = uploaderyInput.files[0].name
            if (newScriptRadio) {
              newScriptRadio.value = filename
            }
          }
        }

        uploaderyInput.addEventListener('click', clearUploadError)
        uploaderyInput.addEventListener('focus', clearUploadError)

        uploaderyInput.addEventListener('change', () => {
          if (uploaderyInput.value) {
            clearUploadError()
            updatePrescriptionStatusWithFilename()
          } else if (newScriptRadio) {
            const defaultValue = newScriptRadio.getAttribute('value')
            if (defaultValue) {
              newScriptRadio.value = defaultValue
            }
          }
        })

        fileUploadContainer.addEventListener('click', clearUploadError)

        observer.disconnect()
      }
    })

    observer.observe(uploadField, { childList: true, subtree: true })
  }

  setTimeout(observeFileInput, UPLOADERY_INIT_DELAY)

  if (newScriptRadio && repeatRadio) {
    newScriptRadio.addEventListener('change', toggleUploadField)
    repeatRadio.addEventListener('change', toggleUploadField)
  }

  if (productForm) {
    productForm.addEventListener('submit', validatePrescriptionForm, true)
  }

  function resetPrescriptionForm() {
    if (petNameInput) {
      petNameInput.value = ''
      petNameInput.style.borderColor = ''
    }

    if (newScriptRadio) {
      newScriptRadio.checked = true
    }

    if (repeatRadio) {
      repeatRadio.checked = false
    }

    const uploaderyInput = uploadField.querySelector('input[type="file"]')
    if (uploaderyInput) {
      uploaderyInput.value = ''
      const event = new Event('change', { bubbles: true })
      uploaderyInput.dispatchEvent(event)
    }

    const uploaderyDisplay = uploadField.querySelector('.spb-file-name')
    if (uploaderyDisplay) {
      uploaderyDisplay.textContent = ''
    }

    const uploaderyRemoveButton = uploadField.querySelector('.spb-remove-file')
    if (uploaderyRemoveButton) {
      uploaderyRemoveButton.click()
    }

    if (petNameError) {
      petNameError.classList.add('hidden')
    }

    if (uploadError) {
      uploadError.classList.add('hidden')
    }

    if (fileSupport) {
      fileSupport.classList.remove('hidden')
    }

    const fileUploadContainer = uploadField.querySelector('.spb-fileupload')
    if (fileUploadContainer) {
      fileUploadContainer.style.borderColor = ''
    }

    toggleUploadField()
  }

  document.addEventListener('cart:item-added', resetPrescriptionForm)

  toggleUploadField()

  const tooltipButtons = document.querySelectorAll('.prescription-info-icon')
  let activeTooltip = null

  const positionTooltipOnMobile = (tooltip) => {
    if (window.innerWidth > 767) {
      tooltip.style.transform = ''
      tooltip.style.removeProperty('--arrow-left')
      return
    }

    const buttonRect = tooltip.previousElementSibling.getBoundingClientRect()
    const leftOffset = buttonRect.left - 16
    const arrowLeftPosition = buttonRect.left + (buttonRect.width / 2) - 16

    tooltip.style.transform = `translateX(-${leftOffset}px)`
    tooltip.style.setProperty('--arrow-left', `${arrowLeftPosition}px`)
  }

  tooltipButtons.forEach(button => {
    const tooltip = button.nextElementSibling
    if (!tooltip || !tooltip.classList.contains('prescription-tooltip-content')) return

    let hoverTimeout = null
    let isOpenedByClick = false

    const showTooltip = () => {
      if (activeTooltip && activeTooltip !== tooltip) {
        activeTooltip.classList.remove('show')
        activeTooltip.classList.add('hidden')
      }
      tooltip.classList.remove('hidden')
      tooltip.classList.add('show')
      positionTooltipOnMobile(tooltip)
      activeTooltip = tooltip
    }

    const hideTooltip = () => {
      if (isOpenedByClick) return

      tooltip.classList.remove('show')
      tooltip.classList.add('hidden')
      if (activeTooltip === tooltip) {
        activeTooltip = null
      }
    }

    button.addEventListener('click', (e) => {
      e.preventDefault()
      e.stopPropagation()
      if (tooltip.classList.contains('show')) {
        isOpenedByClick = false
        hideTooltip()
      } else {
        isOpenedByClick = true
        showTooltip()
      }
    })

    button.addEventListener('mouseenter', () => {
      if (isOpenedByClick) return

      clearTimeout(hoverTimeout)
      showTooltip()
    })

    button.addEventListener('mouseleave', () => {
      if (isOpenedByClick) return

      hoverTimeout = setTimeout(hideTooltip, TOOLTIP_HIDE_DELAY)
    })

    tooltip.addEventListener('mouseenter', () => {
      clearTimeout(hoverTimeout)
    })

    tooltip.addEventListener('mouseleave', () => {
      if (isOpenedByClick) return

      hoverTimeout = setTimeout(hideTooltip, TOOLTIP_HIDE_DELAY)
    })
  })

  document.addEventListener('click', (e) => {
    if (e.target.closest('.prescription-tooltip')) return

    tooltipButtons.forEach(button => {
      const tooltip = button.nextElementSibling
      if (tooltip && tooltip.classList.contains('prescription-tooltip-content')) {
        tooltip.classList.remove('show')
        tooltip.classList.add('hidden')
      }
    })
    activeTooltip = null
  })

  window.addEventListener('resize', () => {
    if (activeTooltip) {
      positionTooltipOnMobile(activeTooltip)
    }
  })
})()
